import "./home.scss";
import { type FC } from "react";
import { Link } from "react-router-dom";
import Button from "../../Common/Button";
import { useTitle } from "../../Utilities/TitleHook";

const Home: FC = () => {
    useTitle();

    return (
        <main id="home" className="flex-center">
            <div>
                <h1>Shopfront API</h1>
                <p id="catchline">Build something brilliant.</p>
                <div id="home-buttons">
                    <Link to="/documentation">
                        <Button classes={[ "large-button" ]}>Documentation</Button>
                    </Link>
                    <Link to="/applications">
                        <Button classes={[ "large-button" ]}>Your Applications</Button>
                    </Link>
                    <Link to="/partner">
                        <Button classes={[ "large-button" ]}>Partner Program</Button>
                    </Link>
                </div>
            </div>
        </main>
    );
};

export default Home;
